angular
    .module('pacaapp')
    .config(['APP_CONFIG',
        '$locationProvider',
        '$routeProvider',
        routeConfig
    ]);

function routeConfig(APP_CONFIG, $locationProvider, $routeProvider) {
    $locationProvider.hashPrefix(APP_CONFIG.HASH_PREFIX);

    $routeProvider
        .when('/loc/:locCode/lang/:langCode/', {
            isHome: true,
            templateUrl: 'app/home/Home.html',
            controller: 'HomeController as home',
            reloadOnSearch: false
        })

        .when('/loc/:locCode/', {
            templateUrl: 'app/home/Home.html',
            controller: 'HomeController as home'
        })

        .when('/loc/:locCode/lang/:langCode/search-result', {
            headerFullWidth: true,
            templateUrl: 'app/search/result/SearchResultMain.html',
            controller: 'SearchResultController as searchResult',
            reloadOnSearch: false,
            css: 'resource/css/srpStyle.css'
        })

        .when('/loc/:locCode/lang/:langCode/vehicle-details/:vehicleId/print-preview', {
            printMode: true,
            templateUrl: 'app/vehicledetails/printPreview/printVehicleDetails.html',
            controller: 'VehicleDetailsController as vehicleDetails',
            css: ['resource/css/print.css', 'resource/css/vdpStyle.css']
        })

        .when('/loc/:locCode/lang/:langCode/vehicle-details/:vehicleId', {
            templateUrl: 'app/vehicledetails/VehicleDetails.html',
            controller: 'VehicleDetailsController as vehicleDetails',
            css: ['resource/css/vdpStyle.css', 'resource/css/owlcarousel/1.3.3/owl.carousel.css', 'resource/css/owlcarousel/1.3.3/owl.theme.css', 'resource/css/lightbox2/2.8.2/lightbox.css']
        })

        .when('/loc/:locCode/lang/:langCode/service-center', {
            page: 'MechanicalServices',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

		.when('/loc/:locCode/lang/:langCode/additional-buyer-information', {
            page: 'AdditionalBuyerInformation',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/vehicle-detailing', {
            page: 'VehicleDetailing',
            banner: true,
            defaultLayout: false,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/how-to-buy', {
            page: 'HowToBuy',
            banner: true,
            defaultLayout: true,
            isGeneric: true,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/how-to-sell', {
            page: 'HowToSell',
            banner: true,
            defaultLayout: true,
            isGeneric: true,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/faq', {
            page: 'Faq',
            banner: true,
            defaultLayout: true,
            isGeneric: true,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/transportation-services', {
            page: 'TransportationServices',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/buyer-protection-plan', {
            page: 'BuyerProtectionPlan',
            banner: true,
            defaultLayout: true,
            isGeneric: true,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/arbitration-rules-policies', {
            page: 'ArbitrationRulesPolices',
            banner: true,
            defaultLayout: true,
            isGeneric: true,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/loc/:locCode/lang/:langCode/arbitration-rules-policies-custom', {
            page: 'ArbitrationRulesPolicesCustom',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })

        .when('/page-not-found', {
            isErrorPage: true,
            templateUrl: 'app/layout/pagenotfound/PageNotFoundMain.html',
            controller: 'PageNotFoundController as pageNotFound'
        })

        .when('/', {
            redirectTo: '/loc/' + APP_CONFIG.DEFAULT_HOME + '/',
        })

        .when('/loc/', {
            redirectTo: '/loc/' + APP_CONFIG.DEFAULT_HOME + '/',
        })

        .otherwise({
            redirectTo: '/page-not-found'
        })
        
        .when('/loc/:locCode/lang/:langCode/additional-seller-information', {
            page: 'AdditionalSellerInformation',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })
        
        .when('/loc/:locCode/lang/:langCode/buyer-and-seller-fees', {
            page: 'BuyerAndSellerFees',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })
        
        .when('/loc/:locCode/lang/:langCode/body-shop', {
            page: 'BodyShop',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        })
        
        .when('/loc/:locCode/lang/:langCode/glass-shop', {
            page: 'GlassShop',
            banner: true,
            defaultLayout: true,
            isGeneric: false,
            templateUrl: 'app/staticpage/StaticPageMain.html',
            controller: 'StaticPageController as staticPage'
        });
}


// WEBPACK FOOTER //
// ./app/app.route.js